import { HTTPClient } from '../utils/request'

// eslint-disable-next-line no-undef
const baseURL = `${`${process.env.VUE_APP_CHAT_API_URL}/tickets`}`

export default {
  createTicket: () =>
    HTTPClient({
      baseURL,
      method: `post`,
    }),
  tickets: ({ query = `` }) =>
    HTTPClient({
      baseURL,
      url: query,
    }),
  message: ({ params, payload }) =>
    HTTPClient({
      baseURL,
      method: `post`,
      url: `/${params.ticket_id}/message`,
      data: payload,
    }),
  messages: ({ params }) =>
    HTTPClient({
      baseURL,
      url: `/${params.ticket_id}`,
    }),
  close: ({ params }) =>
    HTTPClient({
      baseURL,
      method: `post`,
      url: `/${params.ticket_id}/finish`,
    }),
}
